import { render, staticRenderFns } from "./ChangeDmnName.vue?vue&type=template&id=f049fe7a&"
import script from "./ChangeDmnName.vue?vue&type=script&lang=js&"
export * from "./ChangeDmnName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports